<app-page-header routerLink="/school/list" origin="Scholen" title="Details"></app-page-header>

<div class="loader-container" *ngIf="item">
    <app-loader *ngIf="loading == true"></app-loader>
    <div id="topBar">
        <div id="nameBar">
            <p>{{item.name}}</p>
            <span *ngIf="item.active" class="badge badge-success">Actief</span>
            <span *ngIf="!item.active" class="badge badge-error">Inactief</span>
        </div>


    </div>
    <app-tab-group [sidebars]="true">
        <app-tab tabTitle="Algemeen" [showEditButton]="true" [borderless]="true" (editButtonClicked)="editSchool()"
            (deleteButtonClicked)="confirmDelete()">
            <div class="container-fluid">
                <div class="row">
                    <!-- Left Side Inputs -->
                    <div class="col-md-8 card">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>Vestigingscode</td>
                                    <td>{{ item.department_number }}</td>
                                </tr>
                                <tr>
                                    <td>Nummer</td>
                                    <td>{{ item.number }}</td>
                                </tr>
                                <tr>
                                    <td>Naam</td>
                                    <td>{{ item.name }}</td>
                                </tr>
                                <tr>
                                    <td>Systeemnaam</td>
                                    <td>{{ item.system_name }}</td>
                                </tr>
                                <tr>
                                    <td>Roepnaam</td>
                                    <td>{{ item.friendly_name }}</td>
                                </tr>
                                <tr>
                                    <td>Type</td>
                                    <td><span *ngIf="item.type">{{ (item.type).toUpperCase() }}</span></td>
                                </tr>
                                <tr>
                                    <td>Locatie</td>
                                    <td>{{ item.location }}</td>
                                </tr>
                                <tr>
                                    <td>Adres</td>
                                    <td>{{ item.address }}</td>
                                </tr>
                                <tr>
                                    <td>Postcode</td>
                                    <td>{{ item.postal_code }}</td>
                                </tr>
                                <tr>
                                    <td>Plaats</td>
                                    <td>{{ item.city }}</td>
                                </tr>
                                <tr>
                                    <td>Land</td>
                                    <td>{{ item.country }}</td>
                                </tr>
                                <tr>
                                    <td>Regio</td>
                                    <td>{{ item.region }}</td>
                                </tr>
                                <tr>
                                    <td>Bevoegd gezag-nummer</td>
                                    <td>{{ item.authority_number }}</td>
                                </tr>
                                <tr>
                                    <td>Brin nummer</td>
                                    <td>{{ item.brin_number }}</td>
                                </tr>
                                <tr>
                                    <td>Vestigingsnummer</td>
                                    <td>{{ item.department_number }}</td>
                                </tr>
                                <tr>
                                    <td>Contactpersoon e-mailadres</td>
                                    <td>{{ item.contact_email }}</td>
                                </tr>
                                <tr>
                                    <td>Verwijder na</td>
                                    <td>{{ item.prune_users_after_months }} maanden</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Right Side: Terms -->
                    <div class="col-md-4">
                        <div class="card p-3">
                            <h5 class="fw-bold mb-3">Voorwaarden</h5>
                            <app-custom-checkbox label="Algemeen"
                                [binding]="item.terms_and_conditions_accepted"></app-custom-checkbox>
                            <app-custom-checkbox label="Privacy overeenkomst"
                                [binding]="item.privacy_agreement_accepted"></app-custom-checkbox>
                            <app-custom-checkbox label="Verwerkings
                                overeenkomst" [binding]="item.processing_agreement_accepted"></app-custom-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </app-tab>

        <app-tab tabTitle="Licenties" [showAddButton]="true" (addButtonClicked)="addLicense()">
            <div class="container-fluid licenseWrapper">
                <select [(ngModel)]="selectedPeriod" (change)="getLicenses()" class="form-select mb-2">
                    <option *ngFor="let range of periods" [value]="range.id">{{ range.name }}</option>
                </select>
                <div class="row">
                    <!-- Loop through each Course Group -->
                    <div class="col-md-6" *ngFor="let courseTitle of getCourseTitles()">
                        <div class="card">
                            <div class="card-header">
                                <img *ngIf="courseImages[courseTitle]" [src]="courseImages[courseTitle]">
                                <p *ngIf="!courseImages[courseTitle]">{{courseTitle}}</p>
                            </div>
                            <div class="card-body">

                                <!-- Optional: Group by Section Titles -->
                                <div *ngFor="let section of getSections(groupedLicenses[courseTitle])">
                                    <h5 class="category-title">{{ section.sectionTitle }}</h5>

                                    <ul class="list-group list-group-flush">
                                        <li *ngFor="let item of section.items"
                                            class="list-group-item d-flex justify-content-between align-items-center">

                                            <p><span *ngIf="item.active_user_count > item.quantity"
                                                    class="warning-icon">⚠</span>
                                                {{ item.chapter.title }}</p>

                                            <span>
                                                <span class="score"
                                                    [ngClass]="{'red-score': item.has_quantity_overflow == true}">{{
                                                    item.active_user_count }}</span>
                                                <span class="van">van</span>
                                                <span class="score">{{ item.quantity }}</span>
                                            </span>
                                        </li>
                                    </ul>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </app-tab>

        <app-tab tabTitle="Activatiecodes">
            <div class="container-fluid licenseWrapper">
                <select [(ngModel)]="selectedPeriod" (change)="getLicenses()" class="form-select mb-2">
                    <option *ngFor="let range of periods" [value]="range.id">{{ range.name }}</option>
                </select>
                <div class="row">
                    <!-- Loop through each Course Group -->
                    <app-table-guru [apiEndpoint]="'/office/entitlement-codes?period_id=' + selectedPeriod"
                        [columnMapping]="[
    { key: 'title', label: 'Vak' },
    { key: 'code', label: 'Code' },
    { key: 'url', label: 'Link' },
    { key: 'start_at', label: 'Startdatum', type: 'date' },
    { key: 'end_at', label: 'Einddatum', type: 'date' },
    { key: 'available_count', label: 'Beschikbaar' },
    { key: 'used_count', label: 'Gebruikt' }
  ]" [itemsPerPage]="10" [openModalComponent]="addFormReference" [reload]="reloadItems">
                    </app-table-guru>
                </div>

            </div>
        </app-tab>

        <app-tab tabTitle="Bestellingen" [showAddButton]="true" (addButtonClicked)="openCreateOrder()">

            <!-- <app-page-header routerLink="/" origin="Home" title="Bestellingen" [showAddButton]="true"
                (buttonClicked)="openModal(null)"></app-page-header> -->

            <app-table-guru [apiEndpoint]="'/office/organisations/' + this.itemId + '/orders'" [columnMapping]="[
    { key: 'number', label: 'Bestelnummer' },
    { key: 'name', label: 'Contact persoon' },
    { key: 'period.name', label: 'Periode' },
    { key: 'created_at', label: 'Datum', type: 'date' },
    { key: 'status', label: 'Status', type: 'statusText' }
  ]" [itemsPerPage]="10" [viewURL]="'/orders/details/'" [openModalComponent]="addFormReference" [reload]="reloadItems"
                class="compact">
            </app-table-guru>
        </app-tab>
        <app-tab tabTitle="Docenten">
            <app-table-guru [actionButtonText]="'Toevoegen'" [showActionButton]="true"
                (actionButtonClicked)="addTeacher()"
                [apiEndpoint]="'/office/organisations/' + this.itemId + '/users?role=teacher'" [columnMapping]="[
        { key: 'name', label: 'Naam' },
        { key: 'email', label: 'Email', type: 'email', cssClass: 'max-width-nowrap' },
        { key: 'role', label: 'Rol', type: 'role' },
        { key: 'Klas', label: 'Klasnaam' },
        { key: 'created_at', label: 'Registratie datum', type: 'date' },
        { key: 'updated_at', label: 'Laatst ingelogd', type: 'date' }
      ]" [itemsPerPage]="10" [reload]="reloadItems">
            </app-table-guru>
        </app-tab>
        <app-tab tabTitle="Managers">
            <app-table-guru [actionButtonText]="'Toevoegen'" [showActionButton]="true"
                (actionButtonClicked)="addManager()"
                [apiEndpoint]="'/office/organisations/' + this.itemId + '/users?role=school_manager,editor'"
                [columnMapping]="[
        { key: 'name', label: 'Naam' },
        { key: 'email', label: 'Email', type: 'email', cssClass: 'max-width-nowrap'  },
        { key: 'role', label: 'Rol', type: 'role' },
        { key: 'Klas', label: 'Klasnaam' },
        { key: 'created_at', label: 'Registratie datum', type: 'date' },
        { key: 'updated_at', label: 'Laatst ingelogd', type: 'date' }
      ]" [itemsPerPage]="10" [reload]="reloadItems">
            </app-table-guru>
        </app-tab>
        <app-tab tabTitle="Leerlingen" [showAddButton]="false">
            <app-table-guru [apiEndpoint]="'/office/organisations/' + this.itemId + '/users?role=student'"
                [columnMapping]="[
            { key: 'email', label: 'Student', type: 'email', cssClass: 'max-width-nowrap'  },
            { key: 'organisation.name', label: 'Klasnaam' },
            { key: 'created_at', label: 'Registratie datum', type: 'date' },
            { key: 'last_logged_in', label: 'Laatst ingelogd', type: 'date' }
          ]" [itemsPerPage]="10" [reload]="reloadItems">
            </app-table-guru>
        </app-tab>
    </app-tab-group>
</div>
